<script>
    import {onMount} from 'svelte';
    import {url} from '@sveltech/routify';
    import {addYears, startOfMonth, format, addDays, isAfter} from 'date-fns';
    import Titulo from "../../../Components/UI/Titulo.svelte";
    import Caja from "../../../Components/UI/Caja.svelte";
    import Subtitulo from "../../../Components/UI/Subtitulo.svelte";
    import Navegacion from "../../../Components/UI/Navegacion.svelte";

    import Anio from "../../../Components/Calendario/Anio.svelte";
    import Loading from "../../../Components/UI/Loading.svelte";

    import store from '../../../Stores/calendario-store';
    import storeGrupo from '../../../Stores/grupo-store';
    import Tipos from "../../../Components/Calendario/Tipos.svelte";
    import Boton from "../../../Components/UI/Boton.svelte";
    import Estado from "../../../Components/Calendario/Estado.svelte";
    import Migas from "../../../Components/UI/Migas/Migas.svelte";
    import Miga from "../../../Components/UI/Migas/Miga.svelte";
    import CopiarCalendario
        from "../../../Components/Grupos/Calendario/CopiarCalendario.svelte";

    export let id;

    let fecha = startOfMonth(new Date());
    let diasSeleccionados = [];
    const dias = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

    let calendario, listado, nombre;

    $: store.cargarDeGrupo(id, fecha.getFullYear());
    $: calendario = $store.calendario;

    onMount(() => storeGrupo.cargar(id));
    let grupo;
    $: grupo = $storeGrupo.grupo;
    $: error = $store.error;

    const cambioDeAnio = e => fecha = addYears(fecha, e.detail);
    const eligeDeTipo = e => store.eligeDeTipo(e.detail);
    const seleccionaDias = () => store.seleccionaDias(diasSeleccionados);
    const aplicarTipo = e => store.aplicaTipoAGrupo(e.detail, grupo);
    const seleccionarSemana = e => store.seleccionarSemana(e.detail.mes, e.detail.dia);
    const seleccionarMes = e => store.seleccionarMes(e.detail);
    const restauraCalendarioDeEmpresa = () => store.restauraDeGrupo(grupo, fecha.getFullYear());
    const copiaCalendarioDeGrupo = e => {
        store.copiarDeGrupo(grupo, fecha.getFullYear(), e.detail);
    };

    let ultimoDia = null;
    const clickEnDia = e => {
        const fecha = e.detail.fecha,
                shift = e.detail.shift;

        let intervalo;
        if (ultimoDia && shift) {
            intervalo = [ultimoDia, fecha];
            intervalo.sort((a, b) => isAfter(a, b) ? 1 : -1);
            intervalo[1] = addDays(intervalo[1], 1);
        } else {
            intervalo = [addDays(fecha, -1), addDays(fecha, 1)];
        }

        store.invierteDias(intervalo);

        ultimoDia = fecha;
    };

    let algunoSeleccionado;
    $: algunoSeleccionado = calendario
            ? Object.keys(calendario.meses).reduce((acc, mes) => {
                return acc + Object.values(calendario.meses[mes]).filter(dia => dia.seleccionado).length;
            }, 0)
            : false;
</script>

<style>
    .contenido {
        display: grid;
        grid-template-columns: 1fr;
        grid-template-rows: max-content;
        grid-gap: var(--padding-global);
    }

    .dias {
        list-style: none;
        margin: 0;
        padding: 0;
    }

    .dia {
        margin: .5em 0;
    }

    @media (min-width: 1024px) {
        .contenido {
            grid-template-columns: 3fr minmax(20em, 1fr);
            grid-template-rows: max-content max-content max-content 1fr;
        }

        .calendario {
            grid-column: 1;
            grid-row: 1 / 4;
        }

        .estado {
            grid-column: 2;
            grid-row: 1;
        }

        .tipos {
            grid-column: 2;
            grid-row: 2;
        }

        .selector {
            grid-column: 2;
            grid-row: 3;
        }

        .copia {
            grid-column: 2;
            grid-row: 4;
        }
    }
</style>

<svelte:head>
    {#if grupo}<title>Calendario de {grupo.nombre}</title>{/if}
</svelte:head>

<Migas>
    <Miga url={$url('/grupos')}>Grupos</Miga>
    {#if grupo}
        <Miga url={$url(`/grupos/${id}`)}>{grupo.nombre}</Miga>
        <Miga actual>Calendario</Miga>
    {/if}
</Migas>

<Titulo>Grupos</Titulo>

{#if grupo}
    <div class="contenido">
        <div class="calendario">
            <Caja>
                <div slot="titulo">
                    <Subtitulo>Calendario de {grupo.nombre}</Subtitulo>
                </div>

                <div slot="botones">
                    <Navegacion etiqueta="izquierda" on:cambio={cambioDeAnio}>
                        Año {fecha.getFullYear()}
                    </Navegacion>
                </div>

                {#if $store.calendario}
                    <Anio on:click-en-dia-de-semana={seleccionarSemana} on:click-en-dia={clickEnDia}
                          on:click-en-mes={seleccionarMes}
                          {calendario} {fecha} seleccionable/>
                {:else}
                    <Loading/>
                {/if}
            </Caja>
        </div>

        <div class="estado">
            <Estado {calendario} diasDeVacaciones={$store.vacaciones}/>
        </div>

        <div class="tipos">
            <Tipos on:elige-de-tipo={eligeDeTipo} on:aplicar-tipo={aplicarTipo}
                   habilitado={algunoSeleccionado} guardando={$store.guardando}/>
        </div>

        <div class="selector">
            <Caja>
                <div slot="titulo">
                    <Subtitulo>Selector de días</Subtitulo>
                </div>

                <ul class="dias">
                    {#each dias as dia, i (dia)}
                        <li class="dia">
                            <input id="dia-{i}" type="checkbox" bind:group={diasSeleccionados}
                                   value={i + 1}>
                            <label for="dia-{i}">{dia}</label>
                        </li>
                    {/each}
                </ul>

                <Boton on:click={seleccionaDias} disabled={diasSeleccionados.length === 0}>
                    Seleccionar
                </Boton>
            </Caja>
        </div>

        <div class="copia">
            <CopiarCalendario
                    on:copiar-de-grupo={copiaCalendarioDeGrupo}
                    on:restaurar-de-empresa={restauraCalendarioDeEmpresa}/>
        </div>
    </div>
{/if}